import React, { useEffect } from 'react'
import { Layout } from 'antd'
import { Redirect, Route, Switch, useHistory } from 'react-router-dom'
import QueryString from 'query-string'

import { useAuthContext } from '../context/auth'
import { SearchProvider } from '../context/search'
import { ExpertsProvider } from '../context/experts'
import { SchedulerProvider } from '../context/scheduler/scheduler'

import Call from './public/call/Call'

import Header from './helpers/Header'
import Search from './helpers/Search'
import Footer from './helpers/Footer'

import { RoutePath, routes } from './routes'

import './main.css'
import { ExpertProfilesProvider } from '../context/expertProfile'
import { ChatProvider } from '../context/chat'
import { useIntegrationContext } from '../context/integration'
import { customSessionStorage } from '../context/customStorage'
import TopBanner from './helpers/TopBanner/TopBanner'
import AccountNotice from './helpers/AccountNotice'
import { currentBrand as hostBrand } from '../config'
import { Helmet } from 'react-helmet'
import { useBrandContext } from '../context/brand'

const { Content } = Layout

function Main() {
	const { auth, actions } = useAuthContext()
	const { integration } = useIntegrationContext()
	const { brand } = useBrandContext()
	const history = useHistory()

	const query: { [key: string]: any } = QueryString.parse(history.location.search, {
		arrayFormat: 'comma',
		parseNumbers: true,
	})

	useEffect(() => {
		const { refreshUser } = query

		if (refreshUser) actions.refreshUser()
	}, [])
	const title = brand.currentBrand?.name ?? hostBrand.title

	return (
		<>
			<Helmet>
				<meta charSet="utf-8" />
				<title>{title}</title>
				<link rel="icon" href={hostBrand.faviconUrl} />
				<meta
					name="title"
					property="og:title"
					content={`${title} connects you on-demand with top consultants, mentors, coaches and executives all ready to help you go farther, faster in your business or careers.`}
				/>
				<meta
					name="image"
					property="og:image"
					content="https://getwiseconnect.com/wp-content/uploads/2022/02/IMG_0573-1.jpg"
				/>
				<meta
					name="description"
					property="og:description"
					content={`${title} connects you on-demand with top consultants, mentors, coaches and executives all ready to help you go farther, faster in your business or careers.`}
				/>
				<meta name="author" property="author" content={title} />
			</Helmet>
			<Switch>
				<Route path="/call/:id" component={Call} />
				<Route>
					<Layout style={{ minHeight: '100vh', alignItems: 'center' }}>
						<ExpertsProvider>
							<SearchProvider>
								<ExpertProfilesProvider>
									<ChatProvider>
										<Header />
										<TopBanner />
										{integration.config?.header !== 'Slim' && <Search />}
										<Content style={{ minHeight: '100%', width: '100%', maxWidth: 1400, margin: 'auto' }}>
											<AccountNotice />
											<SchedulerProvider>
												<Switch>
													{routes.map((route) => {
														let render
														const redirectToLogin = !auth.token && route.private
														const redirectToMain = auth.token && route.public

														if (redirectToLogin) {
															render = () => {
																customSessionStorage.setItem('redirectUrl', history.location.pathname)
																return <Redirect to={RoutePath.Login} />
															}
														} else if (redirectToMain) {
															const newPath = auth.user?.isExpert ? RoutePath.Profile : RoutePath.Experts
															render = () => <Redirect to={newPath} />
														} else {
															render = (props: any) => {
																return route.redirectTo ? (
																	<Redirect to={route.redirectTo} />
																) : (
																	<route.component {...props} />
																)
															}
														}

														return <Route exact={route.exact} key={route.path} path={route.path} render={render} />
													})}
												</Switch>
											</SchedulerProvider>
										</Content>
										<Footer />
									</ChatProvider>
								</ExpertProfilesProvider>
							</SearchProvider>
						</ExpertsProvider>
					</Layout>
				</Route>
			</Switch>
		</>
	)
}

export default Main
